
import React from 'react';
import { cn } from '@/lib/utils';

interface ChatBubbleProps {
  content: string;
  isUser?: boolean;
  timestamp?: string;
  className?: string;
  imageUrl?: string;
}

export const ChatBubble: React.FC<ChatBubbleProps> = ({
  content,
  isUser = false,
  timestamp,
  className,
  imageUrl,
}) => {
  return (
    <div
      className={cn(
        'flex w-full mb-4 animate-fade-up',
        isUser ? 'justify-end' : 'justify-start',
        className
      )}
    >
      <div
        className={cn(
          'max-w-[80%] md:max-w-[70%] rounded-2xl p-4',
          isUser
            ? 'bg-primary text-primary-foreground rounded-tr-none'
            : 'bg-muted rounded-tl-none'
        )}
      >
        {content && <p className="text-sm md:text-base">{content}</p>}
        {imageUrl && (
          <div className="mt-2 rounded-lg overflow-hidden">
            <img
              src={imageUrl}
              alt="Shared media"
              className="w-full h-auto object-cover"
              loading="lazy"
            />
          </div>
        )}
        {timestamp && (
          <div className="mt-1">
            <p
              className={cn(
                'text-xs',
                isUser ? 'text-primary-foreground/80' : 'text-muted-foreground'
              )}
            >
              {timestamp}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatBubble;
